// src/App.js
import React, { useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import "./App.css";
import logo from "./makanaimpact.png";
import mervinPhoto from "./mervin.jpg";
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import MyStory from "./MyStory";
import ThankYou from "./ThankYou";

function HomePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f6f7f9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1100px",
          background: "#ffffff",
          borderRadius: "30px",
          padding: "40px",
          boxShadow: "0 30px 80px rgba(0,0,0,0.08)"
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "40px"
          }}
        >
          <div style={{ flex: "1", minWidth: "280px" }}>
            <img
              src={logo}
              alt="Makana Impact logo"
              style={{ width: "140px", marginBottom: "20px" }}
            />

            <p
              style={{
                fontSize: "15px",
                fontWeight: "700",
                color: "#2e7d32",
                marginBottom: "12px",
                letterSpacing: "0.04em",
                textTransform: "uppercase"
              }}
            >
              Share. Prosper. Thrive.
            </p>

            <h1
              style={{
                fontSize: "56px",
                fontWeight: "800",
                lineHeight: "1.08",
                marginBottom: "16px",
                color: "#111827"
              }}
            >
              Welcome to Makana Impact.
            </h1>

            <p
              style={{
                fontSize: "22px",
                color: "#4b5563",
                marginBottom: "22px",
                fontStyle: "italic",
                lineHeight: "1.5"
              }}
            >
              A real journey of growth, faith, family, wellness, and building
              something meaningful one step at a time.
            </p>

            <p
              style={{
                fontSize: "17px",
                color: "#374151",
                lineHeight: "1.75",
                marginBottom: "16px"
              }}
            >
              I&apos;m Mervin, and this is my space to build in public and share
              the real process as I grow through life.
            </p>

            <p
              style={{
                fontSize: "17px",
                color: "#374151",
                lineHeight: "1.75",
                marginBottom: "20px"
              }}
            >
              No hype. No pressure. Just honest lessons, mindset, wellness,
              family, faith, and the journey behind what I&apos;m building.
            </p>

            <div
              style={{
                background: "#e8f5e9",
                padding: "16px 18px",
                borderRadius: "12px",
                borderLeft: "5px solid #2e7d32",
                maxWidth: "460px"
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "16px",
                  color: "#1f2937",
                  lineHeight: "1.7",
                  fontWeight: "500"
                }}
              >
                You&apos;re welcome here.{" "}
                <Link
                  to="/my-story"
                  style={{
                    color: "#1b5e20",
                    fontWeight: "700",
                    textDecoration: "underline"
                  }}
                >
                  Watch my story
                </Link>
                , get comfortable, and follow the journey at your own pace.
              </p>
            </div>
          </div>

          <div
            style={{
              flex: "1",
              minWidth: "280px",
              textAlign: "center"
            }}
          >
            <img
              src={mervinPhoto}
              alt="Mervin, founder of Makana Impact"
              style={{
                width: "100%",
                maxWidth: "380px",
                borderRadius: "20px",
                boxShadow: "0 20px 40px rgba(0,0,0,0.15)"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    website: ""
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const name = form.name.trim();
    const email = form.email.trim();

    if (form.website) {
      return;
    }

    if (!name) {
      setError("Please enter your name.");
      return;
    }

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      await addDoc(collection(db, "leads"), {
        name,
        email,
        createdAt: serverTimestamp(),
        source: "makanaimpact_v1",
        status: "new"
      });

      setSubmitted(true);
    } catch (err) {
      console.error("ERROR:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return <ThankYou />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/my-story"
        element={
          <MyStory
            form={form}
            loading={loading}
            error={error}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        }
      />
    </Routes>
  );
}

export default App;